import { DrawFeature } from '@agissc/ktag-map';
import useAppState from '../../../AppStore';

const useDrawListElementFn = (feature: DrawFeature) => {
  const setActiveDrawTool = useAppState((state) => state.setActiveDrawTool);
  const setHoveredFeatureId = useAppState((state) => state.setHoveredFeatureId);
  const selectedFeatureId = useAppState((state) => state.selectedFeatureId);
  const setSelectedFeatureId = useAppState((state) => state.setSelectedFeatureId);

  const onSelectFeature = () => {
    const newSelectedFeatureId =
      selectedFeatureId === feature.id ? null : (feature.id as string);
    setSelectedFeatureId(newSelectedFeatureId);
    setActiveDrawTool('selection');
    setHoveredFeatureId(null);
  };
  return { onSelectFeature };
};

export default useDrawListElementFn;
